import { render, staticRenderFns } from "./EstadoCertificadoPage.vue?vue&type=template&id=45762879"
import script from "./EstadoCertificadoPage.js?vue&type=script&lang=js&external"
export * from "./EstadoCertificadoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports